<template>
  <a-radio-group
    v-bind="instance"
    v-model="defaultValue"
    @change="changeRadio($event.target)"
  >
    <span v-for="item in radioList" :key="item.value">
      <!-- <span v-if="item.isSelf" class="custom-radio-input" >
        <span style="marginRight:8px" @click="selectSelfInput">{{item.label}}:</span>
        <a-input-number v-bind="item" :min="0" :value="radioValue" @change="selfInput" />
      </span> -->
      <a-radio
        :value="item.value"
        :class="{ 'custom-radio-input': item.isSelf }"
      >
        <span>{{ item.label }}</span>
        <a-input-number
          v-if="item.isSelf"
          v-bind="item"
          :min="1"
          :value="radioInputValue"
          @change="selfInput"
        />
      </a-radio>
    </span>
  </a-radio-group>
</template>

<script>
export default {
  props: {
    instance: Object // 配置
  },
  data() {
    return {
      defaultValue: null,
      radioList: [], // 选项
      radioInputValue: '', // 自定义单选框值
      isSetting: false // 只设置一次
    }
  },
  watch: {
    instance: {
      handler(nVal) {
        Object.assign(this, { ...nVal }) // 把传入的参数，融合到this中
        this.initCustomInputValue()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.$on('initSettingCustomRadioInputValue', v =>{
      this.$emit('setFormModelValue', 'inputValue', v)
    }
      
    ) // 初始化默认设置一次和表单绑定的输入框的值
  },
  methods: {
    selfInput: function(v) {
      if(v === 0) {
        this.$message.error('输入的数字不能为0!')
      }
      let number = String(v)
      if(number.length > 16){
        this.$message.error('输入的数字过长,长度不能超过16位,请重新输入!')
        return
      }
      this.radioInputValue = v
      this.settingCustomRadioInputValue(v)
    },
    // 给外部的表单设置自定义输入框中的值
    settingCustomRadioInputValue(v) {
      let attribute = this.instance.attribute || 'inputValue'
      this.$set(this.instance, attribute, v)
      this.$emit('setFormModelValue', attribute, v)
    },
    // 清空
    // 重置自定义输入框的值和禁用状态
    resetSelfInput(value) {
      this.radioInputValue = '' // 清空自定义的输入框的值
      this.defaultValue = '' // 清空勾选的value
      if (value === -1) {
        this.settingCustomRadioInputValue('')
      }
      this.resetForbidden(value)
    },
    // 重置禁用
    resetForbidden(value) {
      this.radioList.forEach(item => {
        if (item.value === 'selfRadio') {
          const status = value === 'selfRadio'
          item.disabled = !status
        }
      })
    },
    // 特殊处理自定义的输入框的默认值
    initCustomInputValue() {
      if (this.isSetting) return
      const { customSetDefault, handleCustomResult } = this.instance
      let inputValue = this.instance[this.instance.attribute] || this.instance.inputValue
      let value = this.instance.attribute || 'inputValue'
      if (customSetDefault) {
        // 如果是含有输入框的radio
        this.radioInputValue = inputValue
        let v = inputValue || undefined
        if(v === undefined){
          v = -1
        }
        // this.$emit('initSettingCustomRadioInputValue', v)
        this.$emit('setFormModelValue', value, v)
        if (handleCustomResult) {
          handleCustomResult.call(this, this.instance, inputValue)
        }
      }
    },
    changeRadio(target) {
      const value = target.value
      this.resetSelfInput(value)
      // this.settingCustomRadioInputValue(undefined)
      this.$emit('change', value)
    }
  }
}
</script>
